import colors from '@constants/colors';
import { IconProps } from '@models/icons';

function Side({ color = colors.gray6, ...rest }: IconProps) {
  return (
        <svg width="32" height="18" viewBox="0 0 32 18" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest}>
            <path
                d="M71.5 165C78.1274 165 83.5 170.373 83.5 177V304.5C83.5 311.127 78.1274 316.5 71.5 316.5H-89.3467C-93.2095 316.5 -96.8363 314.64 -99.0908 311.504L-103.409 305.496C-105.664 302.36 -109.291 300.5 -113.153 300.5H-175C-181.627 300.5 -187 295.127 -187 288.5V177C-187 170.373 -181.627 165 -175 165H71.5ZM7.39844 0C9.97354 0.000151798 12.3916 1.24001 13.8945 3.33105L20.6055 12.6689C22.1084 14.76 24.5265 15.9998 27.1016 16H75.5C79.9183 16 83.5 19.5817 83.5 24V45.5C83.5 49.9183 79.9183 53.5 75.5 53.5H-179C-183.418 53.5 -187 49.9183 -187 45.5V8C-187 3.58172 -183.418 0 -179 0H7.39844Z"
                fill={color}/>
        </svg>
  );
}

export default Side;
